import { motion } from "framer-motion"
import { ArrowRight } from "lucide-react"

// No icon pill anymore — just the copy and a premium CTA button (gradient
// fill, subtle shadow, spring hover/tap, arrow that nudges on hover).
const QuickActionsCTA = ({ text, buttonText = "See All", onButtonClick }) => (
  <motion.div
    whileHover={{ scale: 1.01 }}
    transition={{ type: "spring", stiffness: 300, damping: 20 }}
    className="flex items-center justify-between gap-3 p-4 rounded-2xl bg-foreground/[0.02] border border-foreground/[0.06] h-full"
  >
    <p className="text-sm font-medium text-foreground">{text}</p>

    <motion.button
      onClick={onButtonClick}
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: "spring", stiffness: 400, damping: 20 }}
      className="group shrink-0 flex items-center gap-1.5 bg-gradient-to-b from-primary to-primary/85 text-primary-foreground text-sm font-semibold px-4 py-2.5 rounded-xl shadow-[0_1px_2px_rgba(0,0,0,0.08),0_4px_12px_-2px_rgba(0,0,0,0.15)] ring-1 ring-inset ring-white/10 hover:shadow-[0_1px_2px_rgba(0,0,0,0.1),0_8px_20px_-4px_rgba(0,0,0,0.25)] transition-shadow"
    >
      {buttonText}
      <ArrowRight size={14} className="transition-transform duration-200 group-hover:translate-x-0.5" />
    </motion.button>
  </motion.div>
)

export default QuickActionsCTA